import { ReactNode } from 'react';
import { ClockCircleOutlined, DollarCircleOutlined, QuestionCircleOutlined, SwapOutlined, ToolOutlined } from '@ant-design/icons';
import { ExitReason } from '../reasons';

/** One icon per exit reason, shared by the reason list and the support step that reads it back. */
export const REASON_ICONS: Record<ExitReason, ReactNode> = {
  too_expensive: <DollarCircleOutlined />,
  not_using_enough: <ClockCircleOutlined />,
  missing_feature: <ToolOutlined />,
  switching_competitor: <SwapOutlined />,
  other: <QuestionCircleOutlined />
};
